class ActivitiCompleteBusinessDto {
  /** comment */
  comment = "";

  /** localParamEntity */
  localParamEntity = undefined;

  /** paramEntity */
  paramEntity = undefined;

  /** processInstanceId */
  processInstanceId = "";

  /** taskId */
  taskId = "";

  /** userId */
  userId = undefined;
}

class ActivitiDeleteBusinessDto {
  /** deleteReason */
  deleteReason = "";

  /** processInstanceId */
  processInstanceId = "";
}

class ActivitiModelRequestDto {
  /** 描述 */
  description = "";

  /** 模型id */
  id = "";

  /** key */
  key = "";

  /** 模型名称 */
  name = "";
}

class ActivitiProcessInstanceDto {
  /** 业务关联单号 */
  businesskey = "";

  /** 实例id */
  processInstanceId = "";

  /** 节点信息 */
  taskInfoDto = new ActivitiTaskInfoDto();
}

class ActivitiStartBusinessDto {
  /** businesskey */
  businesskey = "";

  /** paramEntity */
  paramEntity = undefined;

  /** processDefinitionKey */
  processDefinitionKey = "";

  /** startUserId */
  startUserId = "";
}

class ActivitiTaskDto {
  /** 业务单据key */
  businessKey = "";

  /** 是否查当前用户 */
  isCurrentUser = false;
}

class ActivitiTaskInfoDto {
  /** 处理人 */
  assignee = "";

  /** 候选组 */
  candidateGroups = [];

  /** 候选人 */
  candidateUserIds = [];

  /** 变量数据 */
  data = undefined;

  /** 当前节点 */
  taskNode = "";
}

class ActivitiTaskRequestDto {
  /** 处理人 */
  assignee = "";

  /** 业务单据key */
  businessKey = "";

  /** 创建时间 */
  createTime = "";

  /** 任务描述 */
  description = "";

  /** 处理时间 */
  endTime = "";

  /** 流程名称 */
  processDefinitionName = "";

  /** 流程描述 */
  processInstanceDescription = "";

  /** 实例id */
  processInstanceId = "";

  /** 发起人 */
  startUserId = "";

  /** 任务id */
  taskId = "";

  /** 任务名称 */
  taskName = "";
}

class ActivitiTransferTaskDto {
  /** 任务id */
  taskId = "";

  /** 用户信息 */
  userCode = "";
}

class ApprovalConditionRequestDto {
  /** 审批状态 */
  approvalStatus = undefined;

  /** 审批状态 */
  processInstanceIdList = [];

  /** 用户id */
  userId = undefined;
}

class BatchTransferTaskDto {
  /** 业务key，当taskIds空时有效 */
  businessKey = "";

  /** 流程id，当taskIds空时有效 */
  processInstanceId = "";

  /** 原处理人，要求已离职 */
  sourceAssignee = "";

  /** 目标处理人，要求在职 */
  targetAssignee = "";

  /** 任务id列表，不传则使用流程id和业务key字段筛选 */
  taskIds = [];
}

class BpmActivitiCompleteBusinessDto {
  /** actionName */
  actionName = "";

  /** appId */
  appId = "";

  /** backHandMode */
  backHandMode = "";

  /** comment */
  comment = "";

  /** data */
  data = "";

  /** jumpType */
  jumpType = "";

  /** localParamEntity */
  localParamEntity = undefined;

  /** paramEntity */
  paramEntity = undefined;

  /** processInstanceId */
  processInstanceId = "";

  /** rejectTaskId */
  rejectTaskId = "";

  /** taskId */
  taskId = "";

  /** userId */
  userId = "";
}

class BpmActivitiOpinionDto {
  /** 执行人 */
  auditorName = "";

  /** 完成时间 */
  completeTime = "";

  /** 停留时长 */
  durMs = undefined;

  /** 意见 */
  opinion = "";

  /** 待执行人 */
  qualfiedNames = "";

  /** 审批操作 */
  status = "";

  /** 审批操作中文说明 */
  statusVal = "";

  /** 审批节点 */
  taskName = "";
}

class BpmActivitiStartBusinessDto {
  /** appId */
  appId = "";

  /** businesskey */
  businesskey = "";

  /** formKey */
  formKey = "";

  /** formType */
  formType = "";

  /** opinion */
  opinion = "";

  /** paramEntity */
  paramEntity = undefined;

  /** processDefinitionKey */
  processDefinitionKey = "";

  /** startUserId */
  startUserId = "";

  /** supportMobile */
  supportMobile = "";
}

class BpmActivitiTaskDto {
  /** 系统应用id */
  appId = "";

  /** 业务单据key */
  businessKey = "";

  /** 是否查当前用户 */
  isCurrentUser = false;

  /** 流程实例id */
  processInstanceId = "";

  /** 员工工号 */
  userId = "";
}

class BpmActivitiTaskInfoDto {
  /** 处理人 */
  assignee = "";

  /** 候选组 */
  candidateGroups = [];

  /** 候选人 */
  candidateUserIds = [];

  /** 变量数据 */
  data = undefined;

  /** taskId */
  taskId = "";

  /** 当前节点 */
  taskNode = "";
}

class BpmApprovalTaskRequestDto {
  /** 可以不传 */
  appId = "";

  /** 可以不传 */
  businessKey = "";

  /** 格式为 YYYY-MM-DD HH:MM:SS 开始日期与结束日期需要同时传，只传一个另一个将取当前日期 可以不传 */
  endTime = "";

  /** 可以不传 */
  instanceId = "";

  /** pageNumber */
  pageNumber = undefined;

  /** pageSize */
  pageSize = undefined;

  /** 可以不传 */
  processDefinitionName = "";

  /** 格式为 YYYY-MM-DD HH:MM:SS 开始日期与结束日期需要同时传，只传一个另一个将取当前日期 可以不传 */
  startTime = "";

  /** 可以不传 */
  startUserId = "";

  /** 可以不传 */
  startUserName = "";

  /** 可以不传 */
  taskId = "";

  /** 可以不传 */
  taskName = "";

  /** todo:待办,done:已办,myreq:我的请求,todoread:待阅,delegate:转交 */
  taskStatus = "";

  /** userCode */
  userCode = "";
}

class BpmDefinitionDto {
  /** BPMN - 流程发布ID */
  bpmnId = "";

  /** 流程定义ID */
  defId = "";

  /** 流程KEY */
  key = "";

  /** 流程名称 */
  name = "";
}

class BpmFlowCategroyDto {
  /** flowList */
  flowList = [];

  /** flowType */
  flowType = "";

  /** typeName */
  typeName = "";
}

class BpmFlowDefineDto {
  /** createTime */
  createTime = "";

  /** defKey */
  defKey = "";

  /** flowName */
  flowName = "";

  /** status */
  status = "";

  /** verison */
  verison = undefined;
}

class BpmHostUrlConvert {
  /** businessKeyPrefix */
  businessKeyPrefix = "";
}

class BpmnUserTask {
  /** id */
  id = "";

  /** name */
  name = "";
}

class BusinessTaskResponseDto {
  /** 处理人 */
  assignee = "";

  /** 业务单据key */
  businessKey = "";

  /** 创建时间 */
  createTime = "";

  /** 任务描述 */
  description = "";

  /** 处理时间 */
  endTime = "";

  /** 移动端地址 */
  mobileTaskUrl = "";

  /** PC端地址 */
  pcTaskUrl = "";

  /** 流程名称 */
  processDefinitionName = "";

  /** 流程描述 */
  processInstanceDescription = "";

  /** 实例id */
  processInstanceId = "";

  /** 发起人 */
  startUserId = "";

  /** 系统编码 */
  systemCode = "";

  /** 系统名称 */
  systemName = "";

  /** 任务id */
  taskId = "";

  /** 任务名称 */
  taskName = "";
}

class ByteArrayEntity {
  /** bytes */
  bytes = "";

  /** deploymentId */
  deploymentId = "";

  /** id */
  id = "";

  /** name */
  name = "";

  /** persistentState */
  persistentState = undefined;

  /** revision */
  revision = undefined;

  /** revisionNext */
  revisionNext = undefined;
}

class FinanceApprovalStartRequestDto {
  /** 期望日期 */
  expectDate = "";

  /** 采购单号 */
  pono = "";

  /** 付款申请单号 */
  pyno = "";

  /** 备注 */
  remark = "";
}

class HistoricActivityInstanceDto {
  /** instanceTaskList */
  instanceTaskList = [];

  /** processInstance */
  processInstance = new HistoricProcessInstanceEntity();
}

class HistoricActivityInstanceTaskDto {
  /** activityId */
  activityId = "";

  /** activityName */
  activityName = "";

  /** activityType */
  activityType = "";

  /** assignee */
  assignee = "";

  /** calledProcessInstanceId */
  calledProcessInstanceId = "";

  /** deleteReason */
  deleteReason = "";

  /** deploymentId */
  deploymentId = "";

  /** durationInMillis */
  durationInMillis = undefined;

  /** endTime */
  endTime = "";

  /** executionId */
  executionId = "";

  /** id */
  id = "";

  /** processDefinitionId */
  processDefinitionId = "";

  /** processDefinitionKey */
  processDefinitionKey = "";

  /** processDefinitionName */
  processDefinitionName = "";

  /** processDefinitionVersion */
  processDefinitionVersion = undefined;

  /** processInstanceId */
  processInstanceId = "";

  /** startTime */
  startTime = "";

  /** taskId */
  taskId = "";
}

class HistoricProcessInstanceEntity {
  /** businessKey */
  businessKey = "";

  /** deleteReason */
  deleteReason = "";

  /** deploymentId */
  deploymentId = "";

  /** description */
  description = "";

  /** durationInMillis */
  durationInMillis = undefined;

  /** endActivityId */
  endActivityId = "";

  /** endTime */
  endTime = "";

  /** id */
  id = "";

  /** localizedDescription */
  localizedDescription = "";

  /** localizedName */
  localizedName = "";

  /** name */
  name = "";

  /** persistentState */
  persistentState = undefined;

  /** processDefinitionId */
  processDefinitionId = "";

  /** processDefinitionKey */
  processDefinitionKey = "";

  /** processDefinitionName */
  processDefinitionName = "";

  /** processDefinitionVersion */
  processDefinitionVersion = undefined;

  /** processInstanceId */
  processInstanceId = "";

  /** processVariables */
  processVariables = undefined;

  /** queryVariables */
  queryVariables = [];

  /** startActivityId */
  startActivityId = "";

  /** startTime */
  startTime = "";

  /** startUserId */
  startUserId = "";

  /** superProcessInstanceId */
  superProcessInstanceId = "";

  /** tenantId */
  tenantId = "";
}

class HistoricVariableInstanceEntity {
  /** byteArrayValue */
  byteArrayValue = new ByteArrayEntity();

  /** byteArrayValueId */
  byteArrayValueId = "";

  /** bytes */
  bytes = "";

  /** cachedValue */
  cachedValue = undefined;

  /** createTime */
  createTime = "";

  /** doubleValue */
  doubleValue = undefined;

  /** executionId */
  executionId = "";

  /** id */
  id = "";

  /** lastUpdatedTime */
  lastUpdatedTime = "";

  /** longValue */
  longValue = undefined;

  /** name */
  name = "";

  /** persistentState */
  persistentState = undefined;

  /** processInstanceId */
  processInstanceId = "";

  /** revision */
  revision = undefined;

  /** revisionNext */
  revisionNext = undefined;

  /** taskId */
  taskId = "";

  /** textValue */
  textValue = "";

  /** textValue2 */
  textValue2 = "";

  /** time */
  time = "";

  /** value */
  value = undefined;

  /** variableName */
  variableName = "";

  /** variableType */
  variableType = new VariableType();

  /** variableTypeName */
  variableTypeName = "";
}

class Model {
  /** category */
  category = "";

  /** createTime */
  createTime = "";

  /** deploymentId */
  deploymentId = "";

  /** id */
  id = "";

  /** key */
  key = "";

  /** lastUpdateTime */
  lastUpdateTime = "";

  /** metaInfo */
  metaInfo = "";

  /** name */
  name = "";

  /** tenantId */
  tenantId = "";

  /** version */
  version = undefined;
}

class ObjectNode {}

class PageInfo {
  /** endRow */
  endRow = undefined;

  /** hasNextPage */
  hasNextPage = false;

  /** hasPreviousPage */
  hasPreviousPage = false;

  /** isFirstPage */
  isFirstPage = false;

  /** isLastPage */
  isLastPage = false;

  /** list */
  list = [];

  /** navigateFirstPage */
  navigateFirstPage = undefined;

  /** navigateLastPage */
  navigateLastPage = undefined;

  /** navigatePages */
  navigatePages = undefined;

  /** navigatepageNums */
  navigatepageNums = [];

  /** nextPage */
  nextPage = undefined;

  /** pageNum */
  pageNum = undefined;

  /** pageSize */
  pageSize = undefined;

  /** pages */
  pages = undefined;

  /** prePage */
  prePage = undefined;

  /** size */
  size = undefined;

  /** startRow */
  startRow = undefined;

  /** total */
  total = undefined;
}

class Response {
  /** code */
  code = "";

  /** failed */
  failed = false;

  /** msg */
  msg = "";

  /** success */
  success = false;

  /** traceId */
  traceId = "";
}

class ResponseDto {
  /** code */
  code = "";

  /** data */
  data = new ActivitiProcessInstanceDto();

  /** failed */
  failed = false;

  /** msg */
  msg = "";

  /** success */
  success = false;

  /** traceId */
  traceId = "";
}

class VariableType {
  /** cachable */
  cachable = false;

  /** typeName */
  typeName = "";
}

export const activiti = {
  ActivitiCompleteBusinessDto,
  ActivitiDeleteBusinessDto,
  ActivitiModelRequestDto,
  ActivitiProcessInstanceDto,
  ActivitiStartBusinessDto,
  ActivitiTaskDto,
  ActivitiTaskInfoDto,
  ActivitiTaskRequestDto,
  ActivitiTransferTaskDto,
  ApprovalConditionRequestDto,
  BatchTransferTaskDto,
  BpmActivitiCompleteBusinessDto,
  BpmActivitiOpinionDto,
  BpmActivitiStartBusinessDto,
  BpmActivitiTaskDto,
  BpmActivitiTaskInfoDto,
  BpmApprovalTaskRequestDto,
  BpmDefinitionDto,
  BpmFlowCategroyDto,
  BpmFlowDefineDto,
  BpmHostUrlConvert,
  BpmnUserTask,
  BusinessTaskResponseDto,
  ByteArrayEntity,
  FinanceApprovalStartRequestDto,
  HistoricActivityInstanceDto,
  HistoricActivityInstanceTaskDto,
  HistoricProcessInstanceEntity,
  HistoricVariableInstanceEntity,
  Model,
  ObjectNode,
  PageInfo,
  Response,
  ResponseDto,
  VariableType,
};
